const STYLES = {
  error: 'bg-red-50 text-red-800 dark:bg-red-800 dark:text-red-300',
  alert: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-300',
  notice: 'bg-green-50 text-green-800 dark:bg-green-800 dark:text-green-300',
}

// Renders an Active Admin styled flash, matching the server-rendered
// active_admin/_flash_messages partial, for client-side notifications.
export function showAdminFlash(type, message) {
  const anchor = document.querySelector('[data-test-page-content]')
  if (!anchor) return

  let wrapper = document.querySelector('[data-admin-flash-wrapper]')
  if (!wrapper) {
    wrapper = document.createElement('div')
    wrapper.className = 'px-2.5 lg:px-5 mb-8'
    wrapper.setAttribute('data-admin-flash-wrapper', '')
    anchor.insertAdjacentElement('beforebegin', wrapper)
  }

  const flash = document.createElement('div')
  flash.className = `flex items-center gap-3 p-4 mb-2 rounded-lg ${STYLES[type]}`
  flash.textContent = message
  wrapper.append(flash)
}
